import axiosClient from "./axiosClient";
const PREFIX_URL = "crm/dung-luong-su-dung";

const capacityUsedApi = {
    getSizeRest: (params) => {
        const url = `${PREFIX_URL}/getSizeRest`;
        return axiosClient.get(url, { params });
    },
    getWarningPackage: (params) => {
        const url = `${PREFIX_URL}/getWarningPackage`;
        return axiosClient.get(url, { params });
    },
    getWarningCert: (params) => {
        const url = `${PREFIX_URL}/getWarningCert`;
        return axiosClient.get(url, { params });
    },
    clearWarning: (data) => {
        const url = `${PREFIX_URL}/clearWarning`;
        return axiosClient.post(url, data);
    },
}

export default capacityUsedApi;
